import React from "react"
import { GoUnlock, GoLock } from "react-icons/go"
import Image from "next/image"
import { motion } from "framer-motion"
import ReactLoading from "react-loading"
import { useAppSelector } from "@/app/redux/hooks/reduxHooks"

export const SeasonTierComponent = () => {
    const rank = useAppSelector((state) => state.dashboard.rank)
    return (
        <section className="block sm:flex gap-5 w-full">
            <div className="my-5 mx-auto sm:my-0 max-w-[300px] sm:w-[200px] h-[268px] p-5 bg-[url('/bronze-bg.webp')] bg-cover slanted-corner-no-bg">
                <section className="flex gap-2">
                    <motion.div
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0, transition: { duration: 0.75, delay: 1.5 } }}
                    >
                        <Image src="/Icon_TierBadge_Bronze.svg" width="60" height="60" alt="Bronze" />
                    </motion.div>
                    <div>
                        <h3
                            className={`font-primary mb-1 ${
                                rank === "Bronze" || rank === "Silver" || rank === "Gold"
                                    ? "text-primary"
                                    : "text-white"
                            }`}
                        >
                            Bronze
                        </h3>
                        <div className="flex">
                            {rank ? (
                                <>
                                    <div>
                                        {rank === "Bronze" || rank === "Silver" || rank === "Gold" ? (
                                            <GoUnlock className="w-[14px] relative top-[3px] mr-1 text-primary" />
                                        ) : (
                                            <GoLock className="w-[14px] relative top-[3px] mr-1 text-red-500" />
                                        )}
                                    </div>
                                    <div>
                                        {rank === "Bronze" || rank === "Silver" || rank === "Gold" ? (
                                            <p className="text-primary">Unlocked</p>
                                        ) : (
                                            <p className="text-red-500">Locked</p>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div>
                                    <ReactLoading type={"cylon"} color={"#fff"} height={20} width={20} />
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                <ul className="list-disc ml-5 mt-4 text-[15px] text-shadow-md font-bold">
                    <li>Leaderboard Access</li>
                    <li>+5% Credit Gain</li>
                    <li>+10% Faster Repair Time</li>
                </ul>
            </div>
            <div className="my-5 mx-auto sm:my-0 max-w-[300px] sm:w-[200px] h-[268px] p-5 bg-[url('/silver-bg.webp')] bg-cover slanted-corner-no-bg">
                <section className="flex gap-2">
                    <motion.div
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0, transition: { duration: 0.75, delay: 1.75 } }}
                    >
                        <Image src="/Icon_TierBadge_Silver.svg" width="60" height="60" alt="Silver" />
                    </motion.div>
                    <div>
                        <h3
                            className={`font-primary mb-1 ${
                                rank === "Silver" || rank === "Gold" ? "text-primary" : "text-white"
                            }`}
                        >
                            Silver
                        </h3>
                        <div className="flex">
                            {rank ? (
                                <>
                                    <div>
                                        {rank === "Silver" || rank === "Gold" ? (
                                            <GoUnlock className="w-[14px] relative top-[3px] mr-1 text-primary" />
                                        ) : (
                                            <GoLock className="w-[14px] relative top-[3px] mr-1 text-red-500" />
                                        )}
                                    </div>
                                    <div>
                                        {rank === "Silver" || rank === "Gold" ? (
                                            <p className="text-primary">Unlocked</p>
                                        ) : (
                                            <p className="text-red-500">Locked</p>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div>
                                    <ReactLoading type={"cylon"} color={"#fff"} height={20} width={20} />
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                <ul className="list-disc ml-5 mt-4 text-[15px] text-shadow-md font-bold">
                    <li>Leaderboard Access</li>
                    <li>+5% Unit XP Gain</li>
                    <li>+10% Credit Gain</li>
                    <li>+15% Faster Repair Time</li>
                    <li>+25% Marks</li>
                </ul>
            </div>
            <div className="my-5 mx-auto sm:my-0 max-w-[300px] sm:w-[200px] h-[268px] p-5 bg-[url('/gold-bg.webp')] bg-cover slanted-corner-no-bg">
                <section className="flex gap-2">
                    <motion.div
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0, transition: { duration: 0.75, delay: 2 } }}
                    >
                        <Image src="/Icon_TierBadge_Gold.svg" width="60" height="60" alt="Gold" />
                    </motion.div>
                    <div>
                        <h3 className={`font-primary mb-1 ${rank === "Gold" ? "text-primary" : "text-white"}`}>Gold</h3>
                        <div className="flex">
                            {rank ? (
                                <>
                                    <div>
                                        {rank === "Gold" ? (
                                            <GoUnlock className="w-[14px] relative top-[3px] mr-1 text-primary" />
                                        ) : (
                                            <GoLock className="w-[14px] relative top-[3px] mr-1 text-red-500" />
                                        )}
                                    </div>
                                    <div>
                                        {rank === "Gold" ? (
                                            <p className="text-primary">Unlocked</p>
                                        ) : (
                                            <p className="text-red-500">Locked</p>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div>
                                    <ReactLoading type={"cylon"} color={"#fff"} height={20} width={20} />
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                <ul className="list-disc ml-5 mt-4 text-[15px] text-shadow-md font-bold">
                    <li>Leaderboard Access</li>
                    <li>+10% Unit XP Gain</li>
                    <li>+15% Credit Gain</li>
                    <li>+25% Faster Repair Time</li>
                    <li>+50% Marks</li>
                </ul>
            </div>
        </section>
    )
}
